import {injectable} from "inversify";

@injectable()
export default abstract class EngineDebug {

    protected constructor() {}

}